<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <hatadialog ref="hatadialog"></hatadialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title> {{$t('Daily-Tour-List')}} </v-toolbar-title>
              <v-spacer></v-spacer>
            

              <v-menu bottom left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list v-if="PB=='TRY'">
                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex pb-3 xs12 sm12 md12>
                  <v-card flat>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 pt-2 md2>
                        <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="KayitTarihiBasla" v-model="KayitTarihiBasla"></tarihcomp>
                      </v-flex>

                      <v-flex xs12 pt-2 sm6 md2>
                        <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="KayitTarihiBitis" v-model="KayitTarihiBitis"></tarihcomp>
                      </v-flex>
                      <v-flex xs12 pt-2 sm6 md3>
                        <genelarama
                                  :autofocuss="true"
                                  apiname="SaticiAra"
                                  :label="$t('Seller-Code')"
                                  v-model="Satici"
                                ></genelarama>
                      </v-flex>
 <v-flex xs12 sm6 md1 pt-2>
                 
                    <v-checkbox
                      v-model="searchOzet"
                      :label="this.$t('Summary-List')"
                      hide-details
                    >
                    </v-checkbox>
                  
                  
                  </v-flex>
                      <v-flex pt-2>
                        <v-layout row wrap align-center full-heigth>
                          <div v-if="load1">
                            <v-btn color="info" @click="getList()" fab small dark>
                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>
                          <div v-if="progress">
                            <v-layout align-center>
                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                            </v-layout>
                          </div>
                         
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md12 pb-3>
                  <v-card flat class="white--text">
                    <v-card flat>
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 sm12>
                            <v-card flat>
                              <v-data-table :headers="headerssatis" :rows-per-page-items="[20,100]" :items="itemssatis"
                                >
                                <template slot="items" slot-scope="props">
                                  <tr @click="git(props.item)" item>
                                    <td class="text-xs-left">{{ props.item.Donem1 | dateformat }}</td>
                                     <td class="text-xs-left">{{ props.item.SaatStr }}</td>
                                      <td class="text-xs-left">{{ props.item.Pax }}</td>
                                         <td class="text-xs-left">
  <a href="#"
     @click.prevent.stop="pnrGit(props.item.PNR_No)"
     style="color:#1976d2; text-decoration:underline; cursor:pointer;">
     {{ props.item.PNR_No }}
  </a>
</td>
                                     <td class="text-xs-left">{{ props.item.TurKodu}}</td>
                                    <td class="text-xs-left">{{ props.item.BulusmaYeri  }}</td>
  <td class="text-xs-left">{{ props.item.Isim }}</td>
                                       <td class="text-xs-left">{{ props.item.Program}}</td>
                                        <td class="text-xs-left">{{ props.item.Arac }}</td>
                                         <td class="text-xs-right">{{ props.item.Rehber }}</td>
                                          <td class="text-xs-left">{{ props.item.RezzKod }}</td>
                                        <td class="text-xs-left">{{ props.item.SaticiKod  }}</td>
                                        <td class="text-xs-left">{{ props.item.GunlukTurKodu  }}</td>
 <td class="text-xs-left">{{ props.item.TurTuru }}</td>
<td class="text-xs-left">{{ props.item.RezDurumu }}</td>
<td class="text-xs-right">{{ props.item.OtelKodu  }}</td>
                                          <td class="text-xs-left">{{ props.item.OtelAdi}}</td>
                                     <td class="text-xs-center">{{ props.item.Ref }}</td>
                                    <td class="text-xs-center">{{ props.item.IslemRef}}</td>
                                    
                                  </tr>
                                </template>
                               
                              </v-data-table>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
                <yetkidialog ref="yetkidialog"></yetkidialog>

              </v-layout>
            </v-form>
          </v-container>

          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
          </v-snackbar>

          <v-dialog v-model="dialogupdate" scrollable persistent max-width="500px">
            <v-card flat color="grey lighten-4">
              <v-card-title>{{ $t('Update') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md12 pa-1>
                    <v-card flat class="white--text">
                      <v-card flat color="grey lighten-5">
                        <v-card-actions>
                          <v-layout row wrap>
                           
                            <!-- <v-flex  xs12 sm12 md12>
                              <v-autocomplete
                                  hide-details
                                  :items="otelitems"
                                  :label="$t('Hotel')"
                                  item-text="isim"
                                  v-model="UpdatePrm.OtelKodu"
                                  item-value="kod"
                                >
                                </v-autocomplete>
                            </v-flex> -->
                             <v-flex  xs11 sm11 md11>
                                <genelarama
                                  :autofocuss="true"
                                  apiname="SaticiAra"
                                  tip="1"
                                  :label="$t('Hotel')"
                                  v-model="UpdatePrm.OtelKodu"
                                ></genelarama>
                               
                              </v-flex>

                              <v-flex xs1 sm1 md1>
                                <v-layout
                                  row
                                  wrap
                                  fill-height
                                  align-end
                                  justify-center
                                >
                                  <minisaticieklecomp
                                    v-model="UpdatePrm.OtelKodu"
                                    :label="$t('Add-hotel-Seller')"
                                    saticiKod="1"
                                  >
                                  </minisaticieklecomp>
                                </v-layout>
                              </v-flex>
                            <!-- <v-flex xs12 sm6 md12>
                              <v-autocomplete
                                  hide-details
                                  :items="aracitems"
                                  :label="$t('Transfer-v4')"
                                  item-text="isim"
                                  v-model="UpdatePrm.Arac"
                                  item-value="kod"
                                >
                                </v-autocomplete>
                             
                            </v-flex> -->
                            <v-flex  xs11 sm11 md11>
                                <genelarama
                                  :autofocuss="true"
                                  apiname="SaticiAra"
                                  tip="2"
                                  :label="$t('Transfer-v4')"
                                  v-model="UpdatePrm.Arac"
                                ></genelarama>
                               
                              </v-flex>

                              <v-flex xs1 sm1 md1>
                                <v-layout
                                  row
                                  wrap
                                  fill-height
                                  align-end
                                  justify-center
                                >
                                  <minisaticieklecomp
                                    v-model="UpdatePrm.Rehber"
                                    :label="$t('Add-guide-Seller')"
                                    saticiKod="6"
                                  >
                                  </minisaticieklecomp>
                                </v-layout>
                              </v-flex>

                            <!-- <v-flex xs12 sm12 md12>
                              <v-autocomplete
                                  hide-details
                                  :items="rehberitems"
                                  :label="$t('Guide')"
                                  item-text="isim"
                                  v-model="UpdatePrm.Rehber"
                                  item-value="kod"
                                  
                                >
                                </v-autocomplete>
                                
                            </v-flex> -->
   <v-flex  xs11 sm11 md11>
                                <genelarama
                                  :autofocuss="true"
                                  apiname="SaticiAra"
                                  tip="6"
                                  :label="$t('Guide')"
                                  v-model="UpdatePrm.Rehber"
                                ></genelarama>
                               
                              </v-flex>

                              <v-flex xs1 sm1 md1>
                                <v-layout
                                  row
                                  wrap
                                  fill-height
                                  align-end
                                  justify-center
                                >
                                  <minisaticieklecomp
                                    v-model="UpdatePrm.Rehber"
                                    :label="$t('Add-guide-Seller')"
                                    saticiKod="6"
                                  >
                                  </minisaticieklecomp>
                                </v-layout>
                              </v-flex>
                           

                            <v-flex xs12 sm12 md12>
                              <v-select
                                  hide-details
                                  :items="turkoduitems"
                                  :label="$t('Tour-Code')"
                                  item-text="Aciklama"
                                  item-value="Kod"
                                  v-model="UpdatePrm.Tip"
                                  
                                >
                                </v-select>
                          </v-flex>
                         
                          <v-flex xs12 sm12 md12>
                            <v-text-field v-model="UpdatePrm.Saat" :label="$t('Hour')" type="time" :rules="[v => !!v || $t('Mandatory-section')]"></v-text-field>
                          </v-flex>
                         
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>


                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="updateiptal()">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="updatekayit()">{{ $t('Apply') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from "../../../../api/auth";
  import tarihcomp from "../../customcomp/tarihim";
  import helpers from "@/components/app/customcomp/helpers.js";
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
  import tool from "../tools";
  import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
  import anatip from "@/components/app/coper/comp/anatip.vue";
  import rez from "../rezervasyon";
  import genelarama from "@/components/app/coper/comp/genelarama.vue";
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import pnrbul from "@/components/app/coper/component/pnrbul.vue";
  import cariaracomp from "@/components/app/customcomp/cariaracomp"
import minisaticieklecomp from "@/components/app/coper/component/minisaticieklecomp.vue";
  export default {
    data() {
      return {
        searchOzet:false,
        itemssatis:[],
        otelitems:[],
        aracitems:[],
        rehberitems:[],
      
        turkoduitems: [],
        menu1: false,
        UpdatePrm:{
           Ref :"",
 Saat :null,
 Rehber :null,
Arac :null,
 OtelKodu :null,
 Tip:null
        },
        PB:'TRY',
        Satici:null,
        tumsirketler:false,
        

        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0
        },
       
        search: "",
      

//                                        
//                                     
// 
//                                      
//                                        
//                                       
//  
//
// 
//                                      <td class="text-xs-center">{{ props.item.Ref }}</td>
//                                     <td class="text-xs-center">{{ props.item.IslemRef}}</td>

        headerssatis: [
          {
            text: this.$t('Period-v2') + "1",
            value: "Donem1",
            width: "5%",
            align: "left"
          },
           {
            text: this.$t('Hour'),
            value: "SaatStr",
            width: "5%",
            align: "left"
          },
             {
            text: this.$t('Pax'),
            value: "Pax",
            width: "5%",
            align: "left"
          },
           {
            text: this.$t('PNR_No'),
            value: "PNR_No",
            width: "5%",
            align: "left"
          },
           {
            text: this.$t('Tour-Code'),
            value: "TurKodu",
            width: "5%",
            align: "left"
          },
              {
            text: this.$t('Meeting-Place'),
            value: "BulusmaYeri",
            width: "10%",
            align: "left"
          },
           {
            text: this.$t('Name'),
            value: "Isim",
            width: "5%",
            align: "left"
          },
            {
            text: this.$t('Program'),
            value: "Program",
            width: "5%",
            align: "left"
          },
            {
            text: "Transfer",
            value: "Arac",
            width: "5%",
            align: "left"
          },
          {
            text: this.$t('Guide'),
            value: "Rehber",
            width: "5%",
            align: "left"
          },
            {
            text: this.$t('Reservation-Code'),
            value: "RezzKod",
            width: "5%",
            align: "left"
          },
            {
            text: this.$t('Seller-Code'),
            value: "SaticiKod",
            width: "5%",
            align: "left"
          },
             {
            text: this.$t('Daily-Tour-Code'),
            value: "GunlukTurKodu",
            width: "10%",
            align: "left"
          },
           {
            text: this.$t('Tour-type'),
            value: "TurTuru",
            width: "10%",
            align: "left"
          },
           {
            text: this.$t('Reservation-Status'),
            value: "CariUnvan",
            width: "10%",
            align: "left"
          },
           {
            text: this.$t('Hotel-Code'),
            value: "OtelKodu",
            width: "5%",
            align: "left"
          },
            {
            text: this.$t('Hotel-Name'),
            value: "OtelAdi",
            width: "10%",
            align: "left"
          },
          
           
          
          
           {
            text: this.$t('Ref'),
            value: "Ref",
            width: "5%",
            align: "left"
          },
      
         
         
         
          
         
          
         
       
         
         
         
         
         
        
        
       
         
         
         
          {
            text: this.$t('Process-Ref'),
            value: "IslemRef",
            width: "10%",
            align: "left"
          },
         
         
        ],
       
      
      

        KayitTarihiBasla: null,
        KayitTarihiBitis: null,
        SaticiKodu:null,
      
        valid: true,
      
        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: "",
        renk1: "info",
        dialogupdate: false,
        searchcari: "",
        progress: false,
        tooltip: false,
        el: null,
        butondurum: true,
        snackbar: false,
        y: "top",
        x: "right",
        mode: "",
        timeout: 6000,
        text1: "",
        dictionary: {
          custom: {
            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            }
          }
        }
      };
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path;
      });
    },
    beforeMount: beforeMount,

    mounted() {

      this.getOtelItems();    
 this.getaracItems(); 
 this.getrehberItems();

      
      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)
      var credentials = JSON.parse(
       window.localStorage.getItem("credentials")
    );
    this.PB=credentials.ParaBirimi;
    this.$validator.localize("en", this.dictionary);
           
            var credentials = JSON.parse(window.localStorage.getItem("credentials"));

            var params = {
              CompanyCode: credentials.SirketKodu
            };

            this.$http
              .post(auth.API_URL + "api/currency/List", params, {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader()
                }
              })
              .then(
                response => {
                  this.doviztipi = response.body;
                },
                response => {
                  if (response.status === 0) {
                    this.text1 = "Service Unavailable-Döviz";
                    this.snackbar = true;
                  } else {
                    this.text1 = "Service Unavailable-Döviz";
                    this.snackbar = true;
                  }
                }
              );

           
    },





    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }
    },

    components: {
      tarihcomp: tarihcomp,
      yetkidialog,
      hatadialog,
      anatip,
      genelarama,
      referansmerkezicomp,
      pnrbul,
      cariaracomp,
      minisaticieklecomp
    },
    watch: {},
    methods: {
       pnrGit(val){
  let url = "#/coper/rezervasyon/index/id?islem=get&PNR_No=" + val;
        window.open(url, "_target");
      },
      getaracItems()
    {
      
      var prm = {
        id: "",
        kod: "",
        aciklama: "",
        tip: 2,
        YurtIcDis:0,
      };
      tool.http_post(this, 'SaticiAra', prm).then(
        response => {
         this.aracitems=response.body;
        },
        response => {
          // this.status = tool.responseToStatus(response);
        }
      );
    },
    getrehberItems()
    {
      
      var prm = {
        id: "",
        kod: "",
        aciklama: "",
        tip: 6,
        YurtIcDis:0,
      };
      tool.http_post(this, 'SaticiAra', prm).then(
        response => {
         this.rehberitems=response.body;
        },
        response => {
          // this.status = tool.responseToStatus(response);
        }
      );
    },
      getOtelItems()
    {
      
      var prm = {
        id: "",
        kod: "",
        aciklama: "",
        tip: 1,
        YurtIcDis:0,
      };
      tool.http_post(this, 'SaticiAra', prm).then(
        response => {
         this.otelitems=response.body;
        },
        response => {
          // this.status = tool.responseToStatus(response);
        }
      );
    },
      turkodugetir(SaticiKod) {
      var params = {
        SaticiKodu: SaticiKod,
      };

      tool.http_post(this, "AcenteTurlar", params).then(
        (response) => {
          this.turkoduitems = response.body.data;
        },
        (response) => {
          this.text1 = this.$t('Location-could-not-found-error-occured');
          this.snackbar = true;
        }
      );
    },
updateiptal()
{
this.dialogupdate=false;
},
updatekayit()
{
  
 
  

 if (this.UpdatePrm.Tip=="")
 {
  this.UpdatePrm.Tip=null;
 }
 if (this.UpdatePrm.OtelKodu=="")
 {
  this.UpdatePrm.OtelKodu=null;
 }
 if (this.UpdatePrm.Arac=="")
 {
  this.UpdatePrm.Arac=null;
 }
 if (this.UpdatePrm.Rehber=="")
 {
  this.UpdatePrm.Rehber=null;
 }
 if (this.UpdatePrm.Saat=="")
 {
  this.UpdatePrm.Saat=null;
 }
if (this.UpdatePrm.Rehber && this.UpdatePrm.Rehber.kod && this.UpdatePrm.Rehber.kod!=null){
  this.UpdatePrm.Rehber=this.UpdatePrm.Rehber.kod;
 }else{
  this.UpdatePrm.Rehber="";
 }
  if (this.UpdatePrm.OtelKodu && this.UpdatePrm.OtelKodu.kod && this.UpdatePrm.OtelKodu.kod!=null){
  this.UpdatePrm.OtelKodu=this.UpdatePrm.OtelKodu.kod;
 }else{
  this.UpdatePrm.OtelKodu="";
 }
  if (this.UpdatePrm.Arac && this.UpdatePrm.Arac.kod && this.UpdatePrm.Arac.kod!=null){
  this.UpdatePrm.Arac=this.UpdatePrm.Arac.kod;
 }else{
  this.UpdatePrm.Arac="";
 }
      tool.http_post(this, "GunlukTurIsimListesiUpdate", this.UpdatePrm).then(
        (response) => {
          this.dialogupdate=false;
          this.getList();
        },
        (response) => {
          this.text1 = this.$t('Location-could-not-found-error-occured');
          this.snackbar = true;
        }
      );


},
      HataYonetimi(response, request, baslik) {
        if (response.status === 500) {
          //Internal Server Error
          this.$refs.hatadialog.open(response, request, baslik);
        } else {
          this.text1 = "Service Unavailable -" + baslik;
          this.snackbar = true;
        }
      },

      git(val) {
  let rehberprm=null;
         if (val.Rehber){
          rehberprm ={kod:val.Rehber, id: "0", isim: val.RehberAd, isimAra: "",YurtIci_YurtDisi:"",CariKod:"",KDV:0};
         }
        let otelprm=null;
         if (val.OtelKodu){
          otelprm ={kod:val.OtelKodu, id: "0", isim: val.OtelAdi, isimAra: "",YurtIci_YurtDisi:"",CariKod:"",KDV:0};
         }
   let transferprm=null;
         if (val.Arac){
          transferprm ={kod:val.Arac, id: "0", isim: val.AracAd, isimAra: "",YurtIci_YurtDisi:"",CariKod:"",KDV:0};
         }

 this.UpdatePrm.Ref=val.Ref;
 this.UpdatePrm.Saat=val.SaatStr;
 this.UpdatePrm.Tip=val.GunlukTurKodu;
 this.UpdatePrm.OtelKodu=otelprm;
 this.UpdatePrm.Arac=transferprm;
 this.UpdatePrm.Rehber=rehberprm;
        this.turkodugetir(val.SaticiKod);
        this.dialogupdate = true;
        
      },
      getList: getList,
      getListExcel,
      
    }
  };

  

  function getList() {
    




      var bastarih = new Date(this.KayitTarihiBasla);
      var bittarih = new Date(this.KayitTarihiBitis);
      var saticiprm=null;
      if (this.Satici!=null)
      {
         saticiprm=this.Satici.kod;
      }
      

      


      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      if (bastarih <= bittarih) {
        this.progress = true;
        this.load1 = false;
        var RaporParam = {}
        RaporParam.Tarih1 = bastarih;
        RaporParam.Tarih2 = bittarih;
        RaporParam.SaticiKod = saticiprm;
        RaporParam.Ozet=this.searchOzet;
        tool.http_post(this, "GunlukTurIsimListesi", RaporParam).then(
          response => {
            if (response.body.Status == true) {
              this.itemssatis = response.body.data;
              this.progress = false;
              this.load1 = true;
            } else {
              this.text1 = response.body.ErrorList[0];
              this.snackbar = true;
              this.progress = false;
              this.load1 = true;
            }
          },
          response => {
            this.HataYonetimi(response, params, 'Günlük Tur Listesi Getirilemedi');
            this.progress = false;
            this.load1 = true;
          }
        );
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true;
      }
    
  }

  function getListExcel() {
    
      var bastarih = new Date(this.KayitTarihiBasla);
      var bittarih = new Date(this.KayitTarihiBitis);
      var saticiprm=null;
      if (this.Satici!=null)
      {
         saticiprm=this.Satici.kod;
      }
     
      

      


      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      if (bastarih <= bittarih) {
        this.progress=true;
        this.load1 = false;
        var RaporParam = {}

      


        RaporParam.Tarih1 = bastarih;
        RaporParam.Tarih2 = bittarih;
        RaporParam.Ozet=this.searchOzet;
        RaporParam.SaticiKod = saticiprm;
 
        tool.api_post_FileDownload(this, "Coper/ExcelGunlukTurIsimListesi", RaporParam).then(
        (response) => {
          tool.CreateDownloadLink(response, "GunlukTurIsimListesi.xlsx");
          this.progress=false;
          this.load1 = true;
        },
        (response) => {
          this.progress=false;
          this.load1 = true;
        }
      );

      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true;
      }
    
  }

  function beforeMount() {}
</script>
<style>
</style>